// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { GridItemProps } from "@insite/mobius/GridItem";
import xOrderInformationStyles from "@steiner/App/SharedStyles/MyAccountPages/Details/OrderInformationStyles";
import { orderInformationStyles } from "@steiner/Overrides/Widgets/OrderApprovalDetails/OrderApprovalDetailsOrderInformation";
import { color, mergeWithCss, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

const gridSharedStyle: GridItemProps = {
    width: [12, 6, 6, 6, 6],
    css: css`
        margin-bottom: 4px;
        flex-direction: row;
    `,
};

orderInformationStyles.orderInformationGridContainer = {
    gap: 0,
    offsetCss: css`
        gap: 24px;
    `,
    css: css`
        border-bottom: 1px solid ${color("common.border")};
        &&& {
            padding-bottom: 24px;
            margin-bottom: 24px;
        }
    `,
};

orderInformationStyles.mainInformationGridContainer = {
    gap: 5,
};

orderInformationStyles.mainInformationGridItem = orderInformationStyles.addressesInformationGridItem = {
    width: 12,
    css: css`
        dipslay: flex;
        flex-direction: column;
        border-bottom: 1px solid ${color("common.border")};
        &&& {
            padding-bottom: 24px;
            @media print {
                margin-bottom: 24px;
            }
        }
    `,
};

orderInformationStyles.orderNumberTitle = {
    ...xOrderInformationStyles.labelWithDots,
};

orderInformationStyles.orderDateTitle = {
    ...xOrderInformationStyles.labelWithDots,
};

orderInformationStyles.poNumberTitle = {
    ...xOrderInformationStyles.labelWithDots,
};

orderInformationStyles.statusTitle = {
    ...xOrderInformationStyles.labelWithDots,
};

orderInformationStyles.orderNumberText = {
    ...xOrderInformationStyles.value,
};

orderInformationStyles.orderDateText = {
    ...xOrderInformationStyles.value,
};

orderInformationStyles.poNumberText = {
    ...xOrderInformationStyles.value,
};

orderInformationStyles.statusText = {
    ...xOrderInformationStyles.value,
};

orderInformationStyles.orderNumberGridItem = {
    ...gridSharedStyle,
};

orderInformationStyles.orderDateGridItem = {
    ...gridSharedStyle,
};

orderInformationStyles.poNumberGridItem = {
    ...gridSharedStyle,
};

orderInformationStyles.statusGridItem = {
    ...gridSharedStyle,
};

orderInformationStyles.notesGridItem = {
    ...gridSharedStyle,
    width: 12,
};

orderInformationStyles.notesTitle = {
    ...xOrderInformationStyles.labelWithDots,
};

orderInformationStyles.notesDescription = {
    ...xOrderInformationStyles.value,
};

orderInformationStyles.orderApprovalDetailsShippingInformation = {
    shippingInformationTitle: {
        ...mergeWithCss(xOrderInformationStyles.address?.informationTitle, {
            css: css`
                margin-bottom: 12px;
            `,
        }),
    },
    shippingAddressTitle: {
        ...mergeWithCss(xOrderInformationStyles.address?.heading, {
            as: "h3",
        }),
    },
    shippingInformationCarrierGridItem: {
        ...gridSharedStyle,
        width: [12, 6, 6, 6, 6],
        css: css`
            display: flex;
            flex-direction: column;
            gap: 8px;
        `,
    },
    shippingInformationDateRequestedGridItem: {
        ...gridSharedStyle,
        width: [12, 6, 6, 6, 6],
        css: css`
            display: flex;
            flex-direction: column;
            gap: 8px;
            ${xScreen("lt", "sm")} {
                flex-basis: 100%;
                max-width: 100%;
            }
        `,
    },
    shippingInformationServiceGridItem: {
        ...gridSharedStyle,
        width: 12,
    },
    shippingCarrierTitle: {
        ...xOrderInformationStyles.labelWithDots,
    },
    shippingCarrierText: {
        ...xOrderInformationStyles.value,
    },
    shippingDateRequestedTitle: {
        ...xOrderInformationStyles.labelWithDots,
    },
    shippingDateRequestedText: {
        ...xOrderInformationStyles.value,
    },
    shippingServiceTitle: {
        ...xOrderInformationStyles.labelWithDots,
    },
    shippingServiceText: {
        ...xOrderInformationStyles.value,
    },
    shippingInformationGridContainer: {
        gap: 0,
    },
    shippingOtherInformationGridContainer: {
        gap: 0,
    },
    shippingInformationAddressGridItem: {
        width: [12, 6, 6, 6, 6],
        css: css`
            flex-direction: column;
            ${xScreen("lte", "xs")} {
                padding-bottom: 24px;
            }
        `,
    },
    shippingOtherInformationGridItem: {
        width: 12,
    },
};

orderInformationStyles.orderApprovalDetailsBillingInformation = {
    billingInformationGridContainer: {
        gap: 0,
    },
    billingInformationTitle: {
        ...xOrderInformationStyles.address?.informationTitle,
    },
    billingAddressTitle: {
        ...mergeWithCss(xOrderInformationStyles.address?.heading, {
            as: "h3",
        }),
    },
    billingCreditCardAddressTitle: {
        ...mergeWithCss(xOrderInformationStyles.address?.heading, {
            as: "h3",
        }),
    },
    billingInformationBillingAddressGridItem: {
        width: [12, 12, 8, 8, 8],
        printWidth: 12,
        css: css`
            flex-direction: column;
        `,
    },
    billingInformationCreditCardAddressGridItem: {
        width: [6, 6, 6, 6, 6],
        printWidth: 6,
        css: css`
            flex-direction: column;
        `,
    },
};

orderInformationStyles.shippingInformationGridItem = orderInformationStyles.billingInformationGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        ${xScreen("lt", "sm")} {
            flex-basis: 100%;
            max-width: 100%;
        }
        @media Print {
            padding-bottom: 24px;
        }
    `,
};

orderInformationStyles.addressesInformationGridContainer = {
    gap: 0,
    offsetCss: css`
        ${xScreen("lt", "sm")} {
            gap: 20px;
        }
    `,
};
